module.exports = __webpack_public_path__ + "img/approval_bg.8e043302.jpg";